import { NextSeoProps } from 'next-seo';
import config from 'src/config';

const baseUrl = process.env.SITE_URL || config.baseCononicalUrl;

const description = 'Native Apps via Machine Programming.  Machines Do It Better.';
const title = 'Apsy Inc';
const site_name = 'Apsy';
const keywords = 'Apsy Create Mobile App, Native Apps, Machine Programming';

export const MAILTO = "mailto:info@apsy.io"

export const links = {
    linkedin: 'https://www.linkedin.com/company/apsymachine',
    facebook: 'https://www.facebook.com/apsymachine',
    instagram: 'https://www.instagram.com/apsymachine/',
    alexLinkedin: 'https://www.linkedin.com/in/alexkwamin/',
    toorajLinkedin: 'https://www.linkedin.com/in/toorajhelmi/',
    paulinaLinkedin: 'https://www.linkedin.com/in/dpaulinav/'
};

const SEO: NextSeoProps = {
    title,
    description,
    additionalMetaTags: [
        {
            property: 'keywords',
            content: keywords
        }
    ],
    openGraph: {
        url: baseUrl,
        title,
        description,

        images: [
            {
                url: `${baseUrl}/images/apsy-image.jpeg`,
                alt: 'Apsy Inc'
            },
            {
                url: `${baseUrl}/images/leads/Tooraj.png`,
                alt: 'Apsy Inc | Tooraj'
            },
            {
                url: `${baseUrl}/images/leads/Paulina.png`,
                alt: 'Apsy Inc | Paulina'
            },
            {
                url: `${baseUrl}/images/leads/Alex.png`,
                alt: 'Apsy Inc | Alex'
            }
        ],
        site_name
    },
    twitter: {
        handle: '@toorajhelmi',
        site: '@apsymachine',
        cardType: 'summary'
    }
};

export default SEO;